<template>
  <div>
    <PageContainer title="Consulta de Carga Horária">
      <div v-if="!loaded" class="d-flex justify-content-center">
        <component
          :animation-duration="1000"
          :is="'SpringSpinner'"
          :color="'#1C2D5A'"
          :size="80"
          class="mx-2"
        >
        </component>
      </div>

      <Box v-else class="form-container" space="medium">
        <form @submit.prevent="handleSubmit">
          <Select
            v-if="role === '2'"
            class="input"
            :options="autoescolas"
            legend="Autoescola"
            placeholder="Autoescola"
            :modelValue="schema"
            @update:modelValue="$event => (this.schema = $event)"
            :disabled="loadingAluno || loading"
          />

          <Select
            class="input"
            :filtered="true"
            :options="alunos"
            legend="Aluno"
            placeholder="Nome do aluno"
            :modelValue="aluno"
            @update:modelValue="$event => (this.aluno = $event)"
            :disabled="loadingAluno || loading"
          />

          <Select
            class="input"
            :filtered="false"
            :options="categorias"
            legend="Categoria"
            placeholder="Categoria desejada"
            :modelValue="categoria"
            @update:modelValue="$event => (this.categoria = $event)"
            :disabled="loadingAluno || loading"
          />

          <Button text="Consultar" color="primary" :disabled="loadingAluno || loading">
            <Magnify :size="18" />
          </Button>
        </form>
      </Box>
    </PageContainer>

    <div v-if="loading" class="d-flex justify-content-center">
      <component
        :animation-duration="1000"
        :is="'SpringSpinner'"
        :color="'#1C2D5A'"
        :size="80"
        class="mx-2"
      >
      </component>
    </div>

    <PageContainer title="Informações do Aluno" v-if="!loading && aulas.length">
      <div v-if="!loaded" class="d-flex justify-content-center">
        <component
          :animation-duration="1000"
          :is="'SpringSpinner'"
          :color="'#1C2D5A'"
          :size="80"
          class="mx-2"
        >
        </component>
      </div>

      <Box v-else class="carga-container" space="medium">
        <div class="section">
          <h5>Categoria: {{ categoriaSelected }}</h5>
          <h3>Carga horária</h3>
          <CargaHorariaPraticaTable :cargaHoraria="cargaHoraria" />
        </div>

        <div class="section">
          <div class="section-header">
            <h3>Lista de Aulas</h3>

            <Button
              @handle:click="handleExport"
              text="Baixar relatório"
              color="primary"
              :disabled="loadingExport || loading"
            >
              <TrayArrowDown :size="18" />
            </Button>
          </div>

          <Table :headers="['Sequência', 'Data', 'Instrutor', 'Veículo', 'Categoria', 'Status']">
            <tr v-for="(aula, key) in aulas" :key="aula.id_aulas_praticas">
              <td>{{ key + 1 }}</td>
              <td>{{ utils.formatDate(aula.inicio) }}</td>
              <td>{{ aula.instrutor }}</td>
              <td>{{ aula.placa }}</td>
              <td>{{ aula.categoria_cnh }}</td>
              <td>
                <span v-show="!aula.id_anotacao_pratica"> AULA MARCADA</span>
                <span v-show="aula.id_anotacao_pratica && !aula.status"
                  >AULA PENDENTE DE ENVIO</span
                >
                <span v-show="aula.status">{{ aula.status }}</span>
              </td>
            </tr>
          </Table>
        </div>
      </Box>
    </PageContainer>
  </div>
</template>

<script>
import urlApi from '@/router/urlApi'
import urlApiV2 from '@/router/urlApiV2'
import * as spinners from 'epic-spinners'
import Magnify from 'icons/Magnify'
import TrayArrowDown from 'icons/TrayArrowDown'
import _export from '../../services/export'
import utils from '../../services/utils'
import Box from '../core/Box'
import Button from '../core/Button'
import PageContainer from '../core/PageContainer'
import Select from '../core/Select'
import Table from '../core/Table'
import CargaHorariaPraticaTable from '../praticas/cargaHorariaPraticaTable'

export default {
  components: {
    ...spinners,
    PageContainer,
    Box,
    Select,
    Button,
    Table,
    CargaHorariaPraticaTable,
    Magnify,
    TrayArrowDown,
  },
  data() {
    return {
      role: localStorage.id_role,
      utils: utils,
      autoescolas: [],
      alunos: [],
      categorias: [
        { value: 1, text: 'ACC' },
        { value: 2, text: 'A' },
        { value: 3, text: 'B' },
        { value: 4, text: 'C' },
        { value: 5, text: 'D' },
        { value: 6, text: 'E' },
      ],
      cargaHoraria: {},
      aulas: [],
      aluno: '',
      categoria: '',
      categoriaSelected: '',
      schema: '',
      loading: false,
      loaded: false,
      loadingAluno: false,
      loadingAlunos: false,
      loadingExport: false,
    }
  },
  async created() {
    const roles = {
      admin: '1',
      monitoramento: '2',
      autoescola: '5',
    }

    switch (this.role) {
      case roles.admin:
      case roles.autoescola:
        this.schema = localStorage.schema
        break
      case roles.monitoramento:
        await this.buscarAutoescolas()
        this.loaded = true
        break
    }
  },
  methods: {
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.fetchAulas()
      }
    },
    validateInputs() {
      if (!this.aluno || !this.categoria) {
        this.toast('Preencha o nome do aluno e a categoria desejada.')

        return false
      }

      return true
    },
    async fetchAulas() {
      this.loading = true

      const params = {
        id: this.aluno,
        schema: this.schema,
        categoria: this.categoria,
      }

      await this.$http
        .get(`${urlApiV2}/alunos/consultar/aulas-praticas`, {
          params,
        })
        .then(async response => {
          this.aulas = response.body.dados

          await this.fetchCargaHoraria()
        })
        .catch(err => {
          this.toast('Erro ao buscar as aulas.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchCargaHoraria() {
      const params = {
        schema: this.schema,
        categoria: this.categoria,
      }

      await this.$http
        .get(`${urlApi}/agendamentos/carga/horaria/${this.aluno}`, {
          params,
        })
        .then(res => {
          this.cargaHoraria = res.body.dados
          this.categoriaSelected = this.categorias.filter(categoria => {
            return categoria.value == this.categoria
          })
          this.categoriaSelected = this.categoriaSelected[0].text
        })
        .catch(err => {
          console.log(err)
          this.toast('Erro ao buscar a carga horária.')
        })
    },
    async buscarAutoescolas() {
      await this.$http.get(`${urlApiV2}/autoescola/todas`).then(response => {
        this.autoescolas = response.body.dados.map(autoescola => {
          const schema = autoescola.tenant_schema

          return { text: autoescola.nome_fantasia, value: schema }
        })
      })
    },
    async loadAlunos() {
      this.loadingAluno = true

      await this.$http
        .get(`${urlApiV2}/alunos/consultar/select/${this.schema}`)
        .then(response => {
          this.alunos = response.body.dados
        })
        .catch(err => {
          this.toast(err)
        })
        .finally(() => {
          this.loaded = true
          this.loadingAluno = false
        })
    },
    async handleExport() {
      this.loadingExport = true

      const params = {
        schema: this.schema,
      }

      await this.$http
        .get(`${urlApi}/alunos/pdf/aulas/praticas/${this.aluno}`, {
          params,
        })
        .then(res => {
          _export.downloadPDF(res.body.dados, 'aulas-praticas')
        })
        .catch(err => {
          this.toast('Erro ao tentar baixar o relatório.')
        })
        .finally(() => {
          this.loadingExport = false
        })
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false,
      })
    },
  },
  watch: {
    async schema(newSchema, oldSchema) {
      await this.loadAlunos()

      this.aluno = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.form-container {
  form {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 2.5rem;

    .input {
      flex: 1;
      max-width: 36.5rem;
    }
  }
}

.carga-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .section {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    h3 {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 700;
      color: #202224;
    }

    .section-header {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
